import BaseLayout from '@/components/PageLayout';
import '@elem/compBlog/blog.scss';
import SeoCommon from 'lowcode/common/SeoCommon';
import ProductBlog from 'lowcode/pages/product-blog';
import { queryEditorDetailBlogOnline } from 'lowcode/utils/service';
import { queryIndexCategoryItems } from 'lowcomp/plugins/blog/common/blog-editor-api/queryIndexCategoryItems';
import BlogNav from '@elem/compBlog/blog-nav';
import SEOlinksA from '@/components/SEOlinksA';

import './blog.scss';

export default function Page({ tempData, locale, id }: any) {
    const { thePage = {} } = tempData;


    return (
        <BaseLayout className="blog-page-index">
            <SeoCommon title={thePage.seoTitle} description={thePage.seoDescription} />
            <SEOlinksA locale={locale} list={[locale]} pathname="blog" />

            {/* <BlogNav title={''} /> */}
            <ProductBlog id={id} data={tempData} />
        </BaseLayout>
    );
}

export async function getServerSideProps({ params, locale }: any) {
    const id = `/${locale}/blog/index`;
    const tempData1: any = await queryEditorDetailBlogOnline(id, locale);
    const tempData: any = await queryIndexCategoryItems(locale, tempData1);
    // 设置是否是博客首页
    const blogTempitem = tempData.theTemp.find((item: any) => item.name === 'BlogListAll');
    if (blogTempitem && tempData.theData[blogTempitem.id]) {
        tempData.theData[blogTempitem.id].isBlogIndex = true;
    }
    return {
        props: {
            tempData,
            locale,
            id,
        },
    };
}
